export const googleConversionCategoryOptions = [
    { id: "PURCHASE", value: "Vendas · Compra" },
    { id: "ADD_TO_CART", value: "Vendas · Adicionar ao carrinho" },
    { id: "BEGIN_CHECKOUT", value: "Vendas · Iniciar finalização de compra" },
    { id: "SUBSCRIBE_PAID", value: "Vendas · Assinatura" },
    { id: "SIGNUP", value: "Leads · Inscrição" },
    { id: "BOOK_APPOINTMENT", value: "Leads · Reservar horário" },
    { id: "CONTACT", value: "Leads · Contato" },
    { id: "GET_DIRECTIONS", value: "Leads · Ver rota" },
    { id: "OUTBOUND_CLICK", value: "Leads · Clique de saída" },
    { id: "REQUEST_QUOTE", value: "Leads · Solicitar cotação" },
    { id: "SUBMIT_LEAD_FORM", value: "Leads · Enviar formulário de lead" },
    { id: "QUALIFIED_LEAD", value: "Leads · Lead qualificado" },
    { id: "CONVERTED_LEAD", value: "Leads · Lead convertido" },
    { id: "PAGE_VIEW", value: "Terceiros · Visualização de página" },
]

export const googleConversionCategoryLabels = Object.fromEntries(
    googleConversionCategoryOptions.map(option => [option.id, option.value])
)
